(() => {
  const ROOT_SELECTOR = '[data-sl-root]';

  function publish(name, data = {}) {
    try { window.Shopify?.analytics?.publish?.(name, data); }
    catch (error) { console.debug('[JBS Station Landing] Analytics skipped', error); }
  }

  function initialize(root) {
    if (!root || root.dataset.slInitialized === 'true') return;
    root.dataset.slInitialized = 'true';

    root.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (event) => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    root.querySelectorAll('.sl-mini-card, .sl-model-buy a, .sl-compare tbody a').forEach((link) => {
      link.addEventListener('click', () => publish('jbs_station_model_click', {
        label: link.textContent.trim(),
        href: link.getAttribute('href')
      }));
    });

    const form = root.querySelector('#JbsStationsProjectForm');
    form?.addEventListener('submit', () => publish('jbs_station_project_enquiry', {
      model: form.elements['contact[stations]']?.value || 'unknown',
      socket_type: form.elements['contact[socket_type]']?.value || 'unknown'
    }));

    publish('jbs_station_landing_view', { language: document.documentElement.lang });
  }

  function initializeAll(container = document) {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
